import React, { useEffect } from 'react';
import withHeader from "../../../hocs/withHeader";
import SocialChannelsButtonsWrapper from "../social_channels/SocialChannelsButtonsWrapper";
import LoginForm from "./LogInForm";
import {clearCredentials} from "../../../../slices/userSlice";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import withFooter from "../../../hocs/withFooter";

function LogIn(props){
    useEffect(() => {
        props.clearCredentials();
    }, []);

    return(
      <section className="login">
        <div className="container">
            <LoginForm/>
            <div className="alternative_login pv-xlg">
                <p className="alternative_login__title">Or log in with:</p>
                <SocialChannelsButtonsWrapper/>
                <p className="alternative_login__login pb-xl">You don’t have an account? <Link to="/register">Sign
                    up</Link></p>
            </div>
        </div>
      </section>)
}

const mapDispatchToProps = { clearCredentials };

export default connect(null, mapDispatchToProps)(withFooter(withHeader(LogIn)));